import { styled } from 'styled-components';

import { colors, spacing, transition } from 'theme/theme';

export const LargeFilePickerWrapper = styled.div`
  position: relative;
`;

export const LargeFilePickerContentWrapper = styled.div`
  display: flex;
  height: 192px;
  width: 100%;
  align-items: center;
  justify-content: center;
  padding: 6px 16px;

  transition:
    outline ${transition},
    background ${transition};
  border-radius: 8px;

  outline: 0 solid ${colors.inputGrey};
  background: ${colors.inputGrey};

  &[data-loading],
  &[data-mouse-active] {
    outline: 4px solid ${colors.softBlue};
    background: ${colors.softBlue};
  }
`;

export const LargeFilePickerContentWithFile = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing[12]};
`;

export const LargeFilePickerContentNoFileSelected = styled.span`
  display: flex;
  flex-direction: column;
  gap: ${spacing[16]};
  align-items: center;
  justify-content: center;
`;
